import React from "react";
import { TablePagination } from "@mui/material";
import { panelListTablePaginationSx } from "./panelCardSx";
import { panelTablePaginationSelectProps } from "./panelSelectSx";

const defaultDisplayedRows = ({ from, to, count }) =>
  `${from}-${to} / ${count !== -1 ? count : `>${to}`}`;

/**
 * Panel listeleri için standart TablePagination — toolbar + sayfa boyutu menüsü SSOT.
 */
export default function PanelTablePagination({
  sx,
  SelectProps,
  labelRowsPerPage = "Sayfa başına:",
  labelDisplayedRows = defaultDisplayedRows,
  ...rest
}) {
  return (
    <TablePagination
      component="div"
      labelRowsPerPage={labelRowsPerPage}
      labelDisplayedRows={labelDisplayedRows}
      SelectProps={{
        ...panelTablePaginationSelectProps(),
        ...SelectProps,
      }}
      sx={{
        ...panelListTablePaginationSx,
        ...sx,
      }}
      {...rest}
    />
  );
}
